<template>
  <div class="pwmat-trial-download-background">
    <div class="pwmat-trial-download-banner">
      <div class="pwmat-trial-download-container">
        <div class="pwmat-trial-download-banner-title">软件下载</div>
      </div>

      <img class="pwmat-trial-download-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-trial-download-container">

     <div class="pwmat-trial-download-content">
       <div class="pwmat-trial-download-content-title">
         <div class="pwmat-trial-download-content-title-text">GPU卡UUID认证LICENSE版本</div>
         <div class="pwmat-trial-download-line"></div>
       </div>


       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="text-align: justify;font-size: 18px">下面所列安装包均采用GPU卡UUID认证LICENSE的方式，龙讯根据用户提供的UUID产生证书文件pwmat.lic，该证书文件需要放在服务器/opt/pwmat/文件夹下,PWmat默认回去该文件夹下去读取LICENSE文件。如用户没有服务器root权限，无法将证书文件放在/opt/pwmat/目录下，可以在运行PWmat时，在PWmat后跟-lic-path参数指定LICENSE文件所在的文件夹：PWmat -lic-path 'path-to-pwmat.lic'。除超算中心以及大规模集群,绝大部分用户均下载该版本进行软件安装或者更新。用户下载PWmat安装包前，请首先确认自己服务器上MPI以及CUDA版本，根据对应关系下载安装包。如有任何操作不明之处请及时联系龙讯工作人员或发送邮件到support@pwmat.com！！！</p>
       </div>

       <div>
         <table class="pwmat-trial-download-introduce-table">
           <tr class="pwmat-trial-download-introduce-th">
             <th class="pwmat-trial-download-introduce-text-th">CUDA版本</th>
             <th class="pwmat-trial-download-introduce-text-th">MPI版本</th>
             <th class="pwmat-trial-download-introduce-text-th">PWmat版本</th>
             <th class="pwmat-trial-download-introduce-text-th">安装包</th>
             <th class="pwmat-trial-download-introduce-text-th">更新时间</th>
           </tr>
           <tr class="pwmat-trial-download-introduce-td" v-for="version in MSTATIONDownload" :key=version @click="showMSTATIONDownloadModal(version.id)">
             <td class="pwmat-trial-download-introduce-text-td">{{version.CUDA}}</td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.OpenMPI}}</td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.PWmatVersion}}</td>
             <td class="pwmat-trial-download-introduce-text-td" style="color: rgba(73,145,201,1)">{{version.installPackage}}
               <!--<a :href="MSTATION_DOWNLOAD+version.downloadUrl">{{version.installPackage}}</a>-->
             </td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.updateTime}}</td>
           </tr>
         </table>
       </div>


       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">注1：<a class="pwmat-trial-download-info-a" @click="toPWmatUpdateFunc">PWmat安装说明</a></p>
       </div>
       
       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">注2：<a class="pwmat-trial-download-info-a" @click="toPWmatGetUUID">获取GPU UUID方法</a></p>
       </div>
       
       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">注3：<a class="pwmat-trial-download-info-a" target="_blank" href="http://download.lonxun.com/pwmat-release-version/gpu_version/uuid_license_version">历史版本下载</a></p>
       </div>

     </div>
    </div>
    
   <div class="pwmat-trial-download-container">

     <div class="pwmat-trial-download-content">
       <div class="pwmat-trial-download-content-title">
         <div class="pwmat-trial-download-content-title-text">启动server.py服务认证LICENSE版本</div>
         <div class="pwmat-trial-download-line"></div>
       </div>


       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="text-align: justify;font-size: 18px">下面所列安装包均采用在集群登录或者管理节点启动server.py服务认证LICENSE的方式，超算中心或大规模集群用户均下载该版本进行软件安装或者更新。用户下载PWmat安装包前，请首先确认自己服务器上MPI以及CUDA版本，根据对应关系下载安装包。特别注意，运行该版本PWmat时，需要在PWmat指定部署server.py服务的节点的IP以及通讯端口，IP和通讯端口设置方法请参考server.py服务安装说明！！！</p>
       </div>

       <div>
         <table class="pwmat-trial-download-introduce-table">
           <tr class="pwmat-trial-download-introduce-th">
             <th class="pwmat-trial-download-introduce-text-th">CUDA版本</th>
             <th class="pwmat-trial-download-introduce-text-th">MPI版本</th>
             <th class="pwmat-trial-download-introduce-text-th">PWmat版本</th>
             <th class="pwmat-trial-download-introduce-text-th">安装包</th>
             <th class="pwmat-trial-download-introduce-text-th">更新时间</th>
           </tr>
           <tr class="pwmat-trial-download-introduce-td" v-for="version in MCLUSTERDownload" :key=version @click="showMCLUSTERDownloadModal(version.id)">
             <td class="pwmat-trial-download-introduce-text-td">{{version.CUDA}}</td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.OpenMPI}}</td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.PWmatVersion}}</td>
             <td class="pwmat-trial-download-introduce-text-td" style="color: rgba(73,145,201,1)">{{version.installPackage}}
               <!--<a :href="MSTATION_DOWNLOAD+version.downloadUrl">{{version.installPackage}}</a>-->
             </td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.updateTime}}</td>
           </tr>
         </table>
       </div>
       
       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">注1：<a class="pwmat-trial-download-info-a" @click="toPWmatUpdateFunc">PWmat安装说明</a></p>
       </div>
       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">注2：<a class="pwmat-trial-download-info-a" @click="toPWmatLicenseFunc">server.py服务安装说明</a></p>
       </div>
       
       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text" style="font-size: 24px">注3：<a class="pwmat-trial-download-info-a" target="_blank" href="http://download.lonxun.com/pwmat-release-version/gpu_version/server_license_version">历史版本下载</a></p>
       </div>

     </div>
    </div>

    <div class="modal fade" id="MSTATIONDownloadModal" tabindex="-1" role="dialog">
      <div class="modal-dialog mstation-download-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >下载</h5>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>
          <div class="modal-body">
            <p>更新说明：{{MSTATION.instruction}}</p>
            <p>下载：<a :href="MSTATION_DOWNLOAD+MSTATION.downloadUrl">{{MSTATION.installPackage}}</a></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default mstation-download-modal-button" data-dismiss="modal">取消</button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal fade" id="MCLUSTERDownloadModal" tabindex="-1" role="dialog">
      <div class="modal-dialog mstation-download-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >下载</h5>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>
          <div class="modal-body">
            <p>更新说明：{{MCLUSTER.instruction}}</p>
            <p>下载：<a :href="MSTATION_DOWNLOAD+MCLUSTER.downloadUrl">{{MCLUSTER.installPackage}}</a></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default mstation-download-modal-button" data-dismiss="modal">取消</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {MSTATIONDownload} from "../../helpers/softwareDownload"
  import {MCLUSTERDownload} from "../../helpers/softwareDownload_server"
  import {MSTATION_DOWNLOAD} from "../../helpers/consts"
  import $ from 'jquery'

  export default {
    name: "companyIntroduce",
    data(){
      return {
        MSTATIONDownload,
        MCLUSTERDownload,
        MSTATION_DOWNLOAD,
        MSTATION:'',
        MCLUSTER:''

      }
    },
    methods:{
      toPWmatUpdateFunc(){
        this.$router.push({ name: 'PWmatUpdateFunc'})
      },
      toPWmatGetUUID(){
        this.$router.push({ name: 'PWmatGetUUID'})
      },
      toPWmatLicenseFunc(){
        this.$router.push({ name: 'PWmatLicenseFunc'})
      },
      showMSTATIONDownloadModal($id){
        this.MSTATION = MSTATIONDownload[$id]
  //      console.log(this.MSTATION)
        $('#MSTATIONDownloadModal').modal('show')
      },
      showMCLUSTERDownloadModal($id){
        this.MCLUSTER = MCLUSTERDownload[$id]
  //      console.log(this.MSTATION)
        $('#MCLUSTERDownloadModal').modal('show')
      }

    }
  }
</script>

<style scoped>
  .pwmat-trial-download-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .pwmat-trial-download-background{
    margin-top: 70px;
  }
  .pwmat-trial-download-banner{
    overflow:hidden;
  }
  .pwmat-trial-download-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .pwmat-trial-download-banner-img{
    min-width:100%;
    height:165px;
  }
  .pwmat-trial-download-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .pwmat-trial-download-content-title{
    padding-top: 50px;
  }
  .pwmat-trial-download-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .pwmat-trial-download-content-note-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 0px;
  }
  .pwmat-trial-download-content-info{
    margin-top: 40px;
  }
  .pwmat-trial-download-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .pwmat-trial-download-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }

  .pwmat-trial-download-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .pwmat-trial-download-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .pwmat-trial-download-introduce-td{
    height: 45px;
    cursor: pointer;
  }
  .pwmat-trial-download-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .pwmat-trial-download-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .pwmat-trial-download-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding: 16px;
  }
  .pwmat-trial-download-info-a{
    cursor: pointer;
  }
  .pwmat-trial-download-info-a:hover,
  .pwmat-trial-download-info-a:active{
    text-decoration:underline;
  }
  .mstation-download-modal{
    margin-top: 10%
  }
  .mstation-download-modal-button:hover,
  .mstation-download-modal-button:active,
  .mstation-download-modal-button:focus{
    box-shadow:none !important;
    outline: none !important;
  }

  @media screen and (max-width:482px) {
    .pwmat-trial-download-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .pwmat-trial-download-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .pwmat-trial-download-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }

</style>
